import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-update-ticket-priority-time',
  templateUrl: './update-ticket-priority-time.component.html',
  styleUrls: ['./update-ticket-priority-time.component.css']
})
export class UpdateTicketPriorityTimeComponent implements OnInit {

  ticketPriority: any = []
  singleTicketPriority: any =[]
  updateForm: any | FormGroup
  timeInHrs : any = []
  formSubmit: any = false

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,private router: Router) { }


  ngOnInit(): void {
    this.getAllByTicketPriority();
  }

  getAllByTicketPriority(){
    // this.generic_service.getAllByTicketPriority().subscribe(
    //   (res:any)=> {
    //     console.log(res)
    //     this.ticketPriority = res.response
    //   },
    //   (err:any)=>{
    //     console.log(err)
    //   }
    // )
  }




  getTicketPriorityByStatus(status: any){
    this.timeInHrs = ""
    this.singleTicketPriority = []

    for(let i=0;this.ticketPriority.length>i;i++){
      if(this.ticketPriority[i].priorityStatus == status){
        this.singleTicketPriority = this.ticketPriority[i]
        // this.updateForm.patchValue({
        //   timeInHrs: this.singleTaskPriority[i].timeInHrs
        // })
        this.timeInHrs = this.ticketPriority[i].timeInHrs
      }
    }
    console.log(this.singleTicketPriority)
  }

  updateTicketPriorityTime(){
    this.formSubmit = true;
    if(this.timeInHrs == ""){
      return
    }
    let body = {
      "priorityStatus": this.singleTicketPriority.priorityStatus,
      "timeInHrs": Number(this.timeInHrs),
      "cid": Number(this.singleTicketPriority.cid)
    }
    console.log(body)
    this.generic_service.updateTicketPriorityTime(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        document.getElementById("closeModalButton1")?.click()

        this.getAllByTicketPriority();
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  keyPressNumbers(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }


}


